import { useRouter } from "./use-router"

export const useCurrentWorkspaceId = () => {
  const router = useRouter()
  return router.query.workspace_id
}
